// CrumbsGrid.jsx              грід папок

import React from 'react';
import PropTypes from 'prop-types';

// /* eslint-disable no-unused-vars */
export default function CrumbsGrid({ authed, path, folders, images = [], videos = [], pdfs = [], files = [], flatMode = false, loading = false, enterFolder }) {

    return (
        <>
            {/* Крихти */}
            <nav className="flex flex-wrap items-center gap-1 text-sm text-gray-700">
                {path.map((p, i) => (
                    <span key={p.id} className="flex items-center">
                        {i > 0 && <span className="opacity-60 mx-1">/</span>}
                        <button className="underline hover:no-underline" onClick={() => enterFolder(p)}>{p.name}</button>
                    </span>
                ))}
                {flatMode && (
                    <span className="ml-2 px-2 py-0.5 text-xs rounded bg-gray-100 border">плоский</span>
                )}
            </nav>

            {files.length != 0 && (
                <div className="mb-3 text-sm text-gray-600 mt-3">
                    {loading ? 'Завантаження…'
                        : files.length === 0 ? (authed ? 'Порожньооооооо в цій папці.' : 'Немає даних. Авторизуйтеся.')
                            : `Папок: ${folders.length} • Зображень: ${images.length} • Відео: ${videos.length} • pdf: ${pdfs.length} • Усього: ${files.length}`}
                </div>
            )}
        </>
    );
}

CrumbsGrid.propTypes = {
    path: PropTypes.object.isRequired,
    authed: PropTypes.object.isRequired,
    folders: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        type: PropTypes.string,
    })),
    images: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        type: PropTypes.string,
        thumb: PropTypes.string,
        url: PropTypes.string,
        mtime: PropTypes.string,
    })),
    videos: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        type: PropTypes.string,
        thumb: PropTypes.string,
        url: PropTypes.string,
        mtime: PropTypes.string,
    })),
    pdfs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        type: PropTypes.string,
        thumb: PropTypes.string,
        url: PropTypes.string,
        mtime: PropTypes.string,
    })),
    files: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        type: PropTypes.string,
        thumb: PropTypes.string,
        url: PropTypes.string,
        mtime: PropTypes.string,
    })),
    enterFolder: PropTypes.func.isRequired,        // (folder) => void
    flatMode: PropTypes.bool,
    loading: PropTypes.bool,
};

CrumbsGrid.defaultProps = {
    path: [],
    authed: [],
    folders: [],
    images: [],
    videos: [],
    pdfs: [],
    files: [],
};
// /* eslint-enable no-unused-vars */